import {mapActions} from 'vuex'
import {SHOW_TOAST_2} from '@/common/lib'

export const forgetPassword = {
  data() {
    return {
      usernameResetPass: '',
      verifyCodeData: {},
      verifyCode: null,
      dismissSecs: 0,
      dismissCountDown: 0
    }
  },
  async created() {
    if (Object.prototype.hasOwnProperty.call(localStorage, 'getVerifyCodeData') && Object.keys(this.verifyCodeData).length === 0) {
      this.verifyCodeData = await JSON.parse(localStorage.getItem('getVerifyCodeData'))
      if (Object.keys(this.verifyCodeData).length) {
        this.dismissSecs = this.verifyCodeData.maxTimeout
        this.showAlert()
      }
    }
  },
  methods: {
    ...mapActions('auth', ['requestVerifyCode', 'onCompareVerifyCode', 'onChangePw']),
    async getVerifyCode() {
      const valid = await this.$refs.formUsernameResetPass.validate()
      if (valid) {
        const res = await this.requestVerifyCode(this.usernameResetPass)
        if (res) {
          this.verifyCodeData = await JSON.parse(localStorage.getItem('getVerifyCodeData'))
          this.dismissSecs = this.verifyCodeData.maxTimeout
          this.showAlert()
          SHOW_TOAST_2('success', `Đã gửi mã xác thực về email: <b>${res.data.message.split(' ')[4].split(',')[0]}</b>`)
        } else {
          SHOW_TOAST_2('error', 'Tài khoản không tồn tại.')
        }
      }
    },
    closeModal() {
      this.$bvModal.hide('cc-modal-center')
    },
    onShowModal() {
      this.usernameResetPass = ''
      this.verifyCode = null
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      this.verifyCodeData.timeout = dismissCountDown
      localStorage.setItem('getVerifyCodeData', JSON.stringify(this.verifyCodeData))
      if (dismissCountDown === 0) {
        this.verifyCode = null
        localStorage.removeItem('getVerifyCodeData')
      }
    },
    showAlert() {
      this.dismissCountDown = this.verifyCodeData.timeout
    },
    async onVerifyCode() {
      const valid = await this.$refs.formVerifyCode.validate()
      if (valid) {
        const param = {
          id: this.verifyCodeData.user_id,
          code: this.verifyCode
        }
        const res = await this.onCompareVerifyCode(param)
        if (res) {
          this.verifyCodeData.timeout = 0
          localStorage.setItem('getVerifyCodeData', JSON.stringify(this.verifyCodeData))
          await this.$router.push({name: 'Change password'})
        } else {
          SHOW_TOAST_2('error', 'Không thể xác thực. Vui lòng thử lại!')
        }
      }
    },
    async onChangePassword() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const data = {
          _param: {
            id: this.verifyCodeData.user_id,
            password: this.passwordConfirm
          },
          _config: {
            headers: {
              'User-Token': this.tempToken
            }
          }
        }
        const res = await this.onChangePw(data)
        if (res) {
          localStorage.removeItem('getVerifyCodeData')
          await this.resetTempToken()
          SHOW_TOAST_2('success', 'Thay đổi mật khẩu thành công.')
          await this.$router.push({name: 'Login'})
        } else {
          SHOW_TOAST_2('error', 'Không thể thực hiện thay đổi mật khẩu. Vui lòng thử lại!')
        }
      }
    }
  }
}
